import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSetupOrder } from 'Services/Features/Order/orderSlice';
import Select from 'react-select';

const SelectSatus = () => {
    const dispatch = useDispatch()
    const [selectedStatusValue, setSelectedStatusValue] = useState(null)

    const optionsStatus = [
        { value: 'pending', label: 'Pending' },
        { value: 'paid', label: 'Paid' },
        { value: 'on_process', label: 'On Process'},
        { value: 'canceled', label: 'Canceled' },
        { value: 'completed', label: 'Completed' },
    ];

    const handleSelectChangeStatus = (selectedOption) => {
        setSelectedStatusValue(selectedOption);
        dispatch(setSetupOrder({
            'status': selectedOption ? selectedOption.value : ''
        }));
    }

    return (
        <Select
            options={optionsStatus}
            className="js-example-basic-single"
            isMulti={false}
            isClearable={true}
            placeholder="Status Reservasi"
            onChange={handleSelectChangeStatus}
            value={selectedStatusValue}
        />
    );
};

export default SelectSatus;